import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocumentVaultMasterRoutingModule } from './document-vault-master-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { PrimengModule } from 'app/shared/modules/primeng.module';
import { FuseCountdownModule } from '@fuse/components';
import { SharedModule } from 'app/shared/modules/shared.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DocumentVaultMasterComponent } from './document-vault-master.component';


@NgModule({
  declarations: [
    DocumentVaultMasterComponent
  ],
  imports: [
    CommonModule,
    DocumentVaultMasterRoutingModule,
    TranslateModule,
    FuseSharedModule,
    HttpClientModule,
    FormsModule,
    PrimengModule,
    FuseCountdownModule,
    SharedModule,
    NgxMaterialTimepickerModule
  ]
})
export class DocumentVaultMasterModule { }
